<bp-right-drawer
	*ngFor="let drawerName of drawersNames$ | async"
	[name]="drawerName"
	(backdropClick)="onBackdropClick()"
	(closedStart)="onActiveDrawerClosedStart()"
	(closed)="onActiveDrawerClosed(drawerName)"
>
</bp-right-drawer>
